import endPointsSections from "../models/endPointsSections";
import { buildAddMessageFormData, fetchGetAuth, fetchStaticJson, postForm, postJson, toFormData } from "../../utils/utils";
import { getMainClassesIds } from "../../utils/userDetailsUtils";
// import { getCourses } from "../cache/coursesCache";
import { entitiesActions } from "./entities-slice";
import { messageOwnerType } from "../../enums/messageOwnerType";
import { sendActionEvent } from "../../utils/analytics/ga4";
import { md5 } from "../../utils/md5Utils";
import Entity from "../models/Entity";
import propertyOverrideActionsType from "../../enums/propertyOverrideActionsType";
import propertyOverrideType from "../../enums/propertyOverrideType";
import entitysType from "../../enums/entitysType";
import entityTypeIds from "../../enums/entityTypeIds";

// todo
let updateEntitiesInProgress = false;

const startUpdateEntities = async () => {
    // If an updateEntities is already in progress, wait for it to complete
    while (updateEntitiesInProgress) {
        await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for 100 milliseconds
    }
    // Mark that an updateEntities is now in progress
    updateEntitiesInProgress = true;
};

const finishUpdateEntities = () => {
    // Mark that the updateEntities has completed
    updateEntitiesInProgress = false;
};

// export const getCacheEntities = () => {
//     return async (dispatch, getState) => {
//         let state = getState();
//         const userId = state.auth.user?.exidentifier;

//         try {
//             if (userId) {
//                 const cacheCourses = await getCourses(userId);

//                 await startUpdateEntities();
//                 state = getState();

//                 // קאש אצלך נשמר כ-courses, אבל אנחנו מזרימים אותו לתוך entities
//                 dispatch(entitiesActions.addCachedEntities({
//                     cacheEntities: cacheCourses,
//                     connectorsProcessStatus: state.uiData.connectorsProcessStatus
//                 }));
//             }
//         }
//         catch (e) {
//             console.error(e);
//         }
//         finally {
//             finishUpdateEntities();
//         }
//     }
// };

export const addEntities = (providerName, entities, endpoint) => {
    return async (dispatch, getState) => {
        await startUpdateEntities();
        const state = getState();
        dispatch(entitiesActions.addOrUpdateEndpointEntities({
            entitiesToUpdate: entities,
            providerName: providerName,
            endpoint: endpoint,
            providers: state.uiData.providers
        }));

        finishUpdateEntities();
    }
};

const getEntitiesByLang = async (lang, domainsColors, grade, state) => {
    let courses = await fetchStaticJson(window.config.coursesList.replace('lang', lang));

    if (grade) {
        // eslint-disable-next-line
        courses = courses.filter(course => !course.fromClass || (course.fromClass <= eval(grade) && course.toClass >= eval(grade)));
    }

    const additinalFields = {
        sections: [endPointsSections.courses],
        languages: [lang],
        endpoints: []
    };

    // הופכים לפורמט Entity כדי שייכנס ל-slice כמו שצריך
    return courses.map(c => {
        const provider = state.uiData.providers.find(provider => provider.name === c.providerName);

        return new Entity({
            ...c,
            ...additinalFields,
            domainColor: domainsColors[c.domain],
            providerName: provider?.name,
            providerLogo: provider?.logo,
            tags: c.tags || provider?.tags,
            id: c.externalId ?? c.id,
            externalId: c.externalId ?? c.id,
            type: entitysType.course
        });
    });
};

export const getFakeEntities = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const grade = state.auth.user?.studentkita;
            const domainsColors = state.uiData.domains.reduce((obj, domain) => {
                obj[domain.name] = domain.color;
                return obj;
            }, {});

            const heEntities = await getEntitiesByLang("he", domainsColors, grade, state);
            const arEntities = await getEntitiesByLang("ar", domainsColors, grade, state);

            dispatch(entitiesActions.addStaticEntities([...heEntities, ...arEntities]));
        }
        catch (e) {
            console.error(e);
        }
    };
};


export const assignCourseToNmmApi = ({ course, nmmId }) => {
    return async (dispatch, getState) => {
        const state = getState();
        const provider = state.uiData.providers.find(p => p.name === course.providerName);
        if (!provider)
            return;
        const body = {
            providerId: provider.systemId,
            entityType: entitysType.course,
            entityId: String(course.externalId),
            propertyId: propertyOverrideType.nmmId,
            newValue: String(nmmId),
            newOverrideMode: propertyOverrideActionsType.add
        };
        const res = await postJson(`${window.config.baseApiUrl}/api/overrideEntities/add`, body);
        sendActionEvent("assign", "new");
        if (res?.status === 200) {
            try {
                await dispatch(markCourseActiveApi({ course, skipGa: true }));
                dispatch(entitiesActions.overrideCourseProperty({
                    courseId: course.externalId,
                    providerName: course.providerName,
                    propertyId: "nmmId",
                    propertyValue: String(nmmId),
                }));
            } catch (e) {
                console.error(e);
            }
        }
    };
};

export const unassignCourseFromNmmApi = ({ course, nmmId }) => {
    return async (dispatch, getState) => {
        const state = getState();
        const provider = state.uiData.providers.find(p => p.name === course.providerName);
        if (!provider)
            return;
        const body = {
            providerId: provider.systemId,
            entityType: entitysType.course,
            entityId: String(course.externalId),
            propertyId: propertyOverrideType.nmmId,
            oldValue: String(nmmId),
            oldOverrideMode: propertyOverrideActionsType.add
        };
        sendActionEvent("assign", "unassign");
        const res = await postJson(`${window.config.baseApiUrl}/api/overrideEntities/Delete`, body);
        if (res?.status === 200) {
            try {
                await dispatch(markCourseActiveApi({ course, skipGa: true }));
                dispatch(entitiesActions.overrideCourseProperty({
                    courseId: course.externalId,
                    providerName: course.providerName,
                    propertyId: "nmmId",
                    propertyValue: null
                }));
            } catch (e) {
                console.error(e);
            }
        };
    };
}

export const replaceCourseNmmApi = ({ course, oldNmmId, newNmmId }) => {
    return async (dispatch, getState) => {
        const state = getState();
        const provider = state.uiData.providers.find(p => p.name === course.providerName);
        if (!provider)
            return;
        const body = {
            providerId: provider.systemId,
            entityType: entitysType.course,
            entityId: String(course.externalId),
            propertyId: propertyOverrideType.nmmId,
            oldValue: String(oldNmmId),
            oldOverrideMode: propertyOverrideActionsType.add,
            newValue: String(newNmmId),
            newOverrideMode: propertyOverrideActionsType.add
        };

        sendActionEvent("assign", "replace");
        const res = await postJson(`${window.config.baseApiUrl}/api/overrideEntities/Update`, body);
        if (res?.status === 200) {
            dispatch(entitiesActions.overrideCourseProperty({
                courseId: course.externalId,
                providerName: course.providerName,
                propertyId: "nmmId",
                propertyValue: String(newNmmId)
            }));
        }
    };
};

export const markCourseInactiveApi = ({ course }) => {
    return async (dispatch, getState) => {
        const state = getState();
        const provider = state.uiData.providers.find(p => p.name === course.providerName);
        if (!provider)
            return;
        const body = {
            providerId: provider.systemId,
            entityType: entitysType.course,
            entityId: String(course.externalId),
            propertyId: propertyOverrideType.tags,
            newValue: "isInactive",
            newOverrideMode: propertyOverrideActionsType.add
        };

        const res = await postJson(`${window.config.baseApiUrl}/api/overrideEntities/Add`, body);

        if (res?.status === 200) {
            sendActionEvent("assign", "inactive");
            dispatch(entitiesActions.overrideCourseProperty({
                courseId: course.externalId,
                providerName: course.providerName,
                propertyId: "tags",
                propertyValue: [...(course.tags || []), "isInactive"]
            }));
        }
    };
};

export const markCourseActiveApi = ({ course, skipGa }) => {
    return async (dispatch, getState) => {
        const state = getState();
        const provider = state.uiData.providers.find(p => p.name === course.providerName);
        if (!provider)
            return;
        const body = {
            providerId: provider.systemId,
            entityType: entitysType.course,
            entityId: String(course.externalId),
            propertyId: propertyOverrideType.tags,
            oldValue: "isInactive",
            oldOverrideMode: propertyOverrideActionsType.add,
        };

        const res = await postJson(`${window.config.baseApiUrl}/api/overrideEntities/Delete`, body);
        if (res?.status === 200) {
            if (!skipGa)
                sendActionEvent("assign", "active");
            dispatch(entitiesActions.overrideCourseProperty({
                courseId: course.externalId,
                providerName: course.providerName,
                propertyId: "tags",
                propertyValue: (course.tags || []).filter(tag => tag !== "isInactive")
            }));
        }
    };
};

export const getMessages = (params) => async (dispatch, getState) => {
    try {
        const state = getState();
        const lang = state.translate?.lang || "he";
        const res = await postJson(`${window.config.baseApiUrl}/widgetmessages/message/filterRange`, { ...params, lang });
        if (res?.ok)
            dispatch(entitiesActions.mergeEntitiesWithTag({
                entities: (res.body ?? []).map(m => {
                    const messageFilters = m.filters ?? [];
                    const isSchoolMessage = messageFilters.some(filter => filter.schoolId != null);
                    const tags = (params?.schoolId && isSchoolMessage) ? ["school"] : params?.schoolId ? [] : ["user"];
                    return {
                        ...m,
                        messageFilters,
                        tags
                    };
                }),
                type: entitysType.message,
            }));

    } catch (e) { console.error("getMessages", e); }
};

export const addOrUpdateUserBoardAccess = (boardKey) => async (dispatch, getState) => {
    try {
        await postJson(`${window.config.baseApiUrl}/api/boardAccess/AddOrUpdate/${boardKey}`);
        const boardGuid = md5(boardKey).toLowerCase();
        const exists = getState().entities.list.some(
            e => e.type === entitysType.board && e.id === boardGuid
        );
        if (exists)
            dispatch(entitiesActions.updateEntity({ entityId: boardGuid, entityType: entitysType.board, updates: { lastAccess: Date.now() } }));
        else
            dispatch(entitiesActions.addEntity({ type: entitysType.board, id: boardGuid, lastAccess: Date.now(), tags: ["nmm"] }));
    } catch (e) { console.error("addOrUpdateUserBoardAccess", e); }
};

export const getUserBoardAccess = () => async (dispatch) => {
    try {
        const res = await postJson(`${window.config.baseApiUrl}/api/boardAccess/FilterRange`);
        if (!res?.ok) return;
        const entities = res.body.map(({ boardKey, lastAccess }) => ({
            type: entitysType.board,
            id: boardKey.toString().toLowerCase(),
            lastAccess: new Date(lastAccess).getTime(),
            tags: ["nmm"],
        }));
        dispatch(entitiesActions.addEntities(entities));
    } catch (e) { console.error("getUserBoardAccess", e); }
};

const normalizeAppletEntity = (e) => ({
    id: e.id,
    type: entitysType.applet,
    name: e.content?.name,
    description: e.content?.description,
    iconUrl: e.content?.iconUrl,
    appletUrl: e.content?.appletUrl,
    requiresContext: e.content?.requiresContext,
    order: e.content?.order,
    tags: e.tags,
    lang: e.lang,
    schoolId: e.schoolId,
    studyGroupId: e.studyGroupId,
    enabled: e.enabled,
});

export const getApplets = () => async (dispatch) => {
    try {
        const res = await postJson(`${window.config.baseApiUrl}/api/entity/FilterRange`, {
            entityType: entityTypeIds.applet,
        });
        if (!res?.ok) return;
        dispatch(entitiesActions.mergeEntitiesWithTag({
            type: entitysType.applet,
            entities: (res.body ?? []).map(normalizeAppletEntity),
        }));
    } catch (e) { console.error("getApplets", e); }
};

export const getStudyGroup = (isStudent = true) => {
    return async (dispatch) => {
        try {
            if (isStudent === true) {
                const res = await fetchGetAuth(`${window.config.baseApiUrl}/api/studygroup/student`);
                if (res) {
                    const groupsArray = toGroupsArray(res);
                    dispatch(entitiesActions.addEntities([...groupsArray.map(sg => ({ type: "studyGroup", ...sg }))]));
                }
            } else {
                const res = await postJson(`${window.config.baseApiUrl}/api/studygroup/my`);
                if (res) {
                    const groupsArray = toGroupsArray(res.body);
                    dispatch(entitiesActions.addEntities([...groupsArray.map(sg => ({ type: "studyGroup", ...sg }))]));
                }
            }
        }

        catch (e) {
            console.log("error", e);
        }
    }
}

export const fetchStudyGroupStudents = (studyGroupId) => {
    return async (dispatch) => {
        try {
            const res = await postJson(
                `${window.config.baseApiUrl}/api/studygroup/filterStudents?id=${studyGroupId}`
            );
            if (res?.ok) {
                const students = res.body.map(s => ({
                    id: s.userId,
                    name: `${s.firstName ?? ''} ${s.lastName ?? ''}`.trim(),
                    present: true,
                }));
                dispatch(entitiesActions.updateEntity({
                    entityId: studyGroupId,
                    entityType: 'studyGroup',
                    updates: { students }
                }));
                return students;
            }
            return [];
        } catch (e) {
            console.log("error", e);
            return [];
        }
    };
};

export const addMessage = (draft) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const user = state.auth.user;
            const formData = toFormData(draft);
            const res = await postForm(`${window.config.baseApiUrl}/widgetmessages/message/add`, formData);
            if (res?.ok) {
                dispatch(entitiesActions.addEntity({
                    type: entitysType.message,
                    tags: draft.tags ?? [],
                    imageFile: draft.messageContents?.[0]?.imageFile,
                    id: res.body,
                    boardId: draft.boardId,
                    fromDate: draft.fromDate,
                    toDate: draft.toDate,
                    nmmIds: draft.messageFilters?.[0]?.studyGroupId ? [draft.messageFilters[0].studyGroupId] : [],
                    important: draft.important,
                    metadata: { firstName: user?.given_name ?? "", lastName: user?.family_name ?? "" },
                    ownerTypeId: messageOwnerType.teacher,
                    messageFilters: (draft.messageFilters ?? []).map(f => ({ ...f, targetGroupTypeId: f.targetGroupTypeId ?? f.targetGroup })),
                    isOwner: true,
                    content: draft.messageContents?.[0]?.content,
                    lang: draft.messageContents?.[0]?.lang,
                }));
                return { ok: true, body: res.body };
            }
            return { ok: false, status: res?.status, body: res?.body };
        }
        catch (e) {
            console.error("addMessage", e);
            return { ok: false, error: "requestFailed" };
        }
    };
};

export const updateMessage = (draft) => {
    return async (dispatch) => {
        try {
            const formData = toFormData(draft);
            const res = await postForm(`${window.config.messagesBaseUrl || window.config.baseApiUrl}/widgetmessages/message/update`, formData);
            if (res?.ok) {
                dispatch(entitiesActions.updateEntity({
                    entityId: draft?.id,
                    entityType: entitysType.message,
                    updates: {
                        fromDate: draft.fromDate,
                        toDate: draft.toDate,
                        boardId: draft.boardId,
                        important: draft.important,
                        nmmIds: draft.messageFilters?.[0]?.studyGroupId ? [draft.messageFilters[0].studyGroupId] : [],
                        targetGroup: draft.messageFilters?.[0]?.targetGroup,
                        content: draft?.messageContents?.[0]?.content,
                        messageFilters: (draft.messageFilters ?? []).map(f => ({ ...f, targetGroupTypeId: f.targetGroupTypeId ?? f.targetGroup })),
                        imageFile: draft.messageContents?.[0]?.imageFile,
                        lang: draft.messageContents?.[0]?.lang,
                    }
                }));
                return { ok: true, body: res.body };
            }
            return { ok: false, status: res?.status, body: res?.body };
        }
        catch (e) {
            console.error("updateMessage", e);
            return { ok: false, error: "requestFailed" };
        }
    };
}

export const deleteMessage = (draft) => {
    return async (dispatch) => {
        try {
            const res = await postJson(`${window.config.baseApiUrl}/widgetmessages/message/delete?id=${draft.id}`);
            if (res?.ok) {
                dispatch(entitiesActions.deleteEntity({
                    entityId: draft.id,
                    entityType: entitysType.message,
                }));
                return { ok: true, body: res.body };
            } else
                return { ok: false, status: res?.status, body: res?.body };
        }
        catch (e) {
            console.error("deleteMessage", e);
            return { ok: false, error: "requestFailed" };
        }
    }
};


const toGroupsArray = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    return Object.values(data).flat(); // אם זה { schoolId: [groups] }
};

